import { useCallback, useEffect } from 'react';
import { MIN_TIMELINE_ZOOM } from '../constants';
import { timelineScrollContainerRef } from '../utils/restore-scroll-after-zoom';
import { useTimelineZoom } from '../timeline/utils/use-timeline-zoom';
import { useTimelineSize } from '../timeline/utils/use-timeline-size';

/**
 * 타임라인 위에서 Ctrl/Cmd + wheel로 줌 인/아웃을 처리하는 컴포넌트
 */
export const TimelineZoomWheel = () => {
  const { setZoom } = useTimelineZoom();
  const { maxZoom, zoomStep } = useTimelineSize();

  const onWheel = useCallback(
    (e: WheelEvent) => {
      const wantsToZoom = e.ctrlKey || e.metaKey;

      if (!wantsToZoom) {
        return;
      }

      e.preventDefault();

      // deltaY > 0: wheel down (줌 아웃)
      // deltaY < 0: wheel up (줌 인)
      const zoomDelta = e.deltaY > 0 ? -zoomStep : zoomStep;

      setZoom((prev) =>
        Math.max(MIN_TIMELINE_ZOOM, Math.min(maxZoom, prev + zoomDelta)),
      );
    },
    [setZoom, maxZoom, zoomStep],
  );

  useEffect(() => {
    const container = timelineScrollContainerRef.current;
    if (!container) {
      return;
    }

    container.addEventListener('wheel', onWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', onWheel);
    };
  }, [onWheel]);

  return null;
};
